import React, { useState } from 'react';
import SmallDialog from '../../lib/dialog/SmallDialog';
import { useParams } from 'react-router-dom';
import Button from '../../lib/button/Button';
import { getAccessToken } from '../../auth';
import { Logger } from '@elyx-code/common-ts-utils';
import { envConfig } from '../../config';

interface IUnpublishProjectConfirmationDialogProps {
	onClose: () => void;
	onUnpublish?: () => void;
}

const UnpublishProjectConfirmationDialog: React.FC<
	IUnpublishProjectConfirmationDialogProps
> = ({ onClose, onUnpublish }) => {
	const [isUnpublishingProject, setIsUnpublishingProject] = useState(false);
	const { id: projectId } = useParams<{ id: string }>();

	const unpublishProject = async () => {
		setIsUnpublishingProject(true);

		const token = await getAccessToken();

		try {
			await fetch(
				`${envConfig.API_BASE_URL}/publishing-service/v1/publications/${projectId}/unpublish`,
				{
					method: 'DELETE',
					headers: {
						Authorization: 'Bearer ' + token,
					},
				}
			);

			onUnpublish?.();
		} catch (error) {
			Logger.log('Unpublish Project error: ', error);
		}
		setIsUnpublishingProject(false);
	};

	return (
		<SmallDialog onClose={() => !isUnpublishingProject && onClose?.()}>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					height: '100%',
					justifyContent: 'space-between',
				}}
			>
				<div style={{ display: 'flex', flexDirection: 'column' }}>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							marginBottom: '10px',
						}}
					>
						<button
							className='dialog_back_button'
							disabled={isUnpublishingProject}
							onClick={(e) => {
								if (!isUnpublishingProject) {
									onClose?.();
								}
							}}
						>
							<i className='fa-solid fa-arrow-left' />
						</button>
						<h2 style={{ margin: '0px', fontWeight: '500' }}>
							Unpublish project
						</h2>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							gap: '10px',
							marginBottom: '16px',
						}}
					>
						<p
							style={{
								margin: '0px',
								marginTop: '6px',
								color: 'rgba(0,0,0,0.54)',
								fontSize: '14px',
							}}
						>
							Are you sure you want to unpublish the project?
						</p>
						<p
							style={{
								margin: '0px',
								marginTop: '6px',
								color: 'rgba(0,0,0,0.54)',
								fontSize: '14px',
							}}
						>
							This action makes the project invisible from your users, and it
							deletes all of its generated data and assets.
						</p>
						<p
							style={{
								margin: '0px',
								marginTop: '6px',
								color: 'rgba(0,0,0,0.54)',
								fontSize: '14px',
							}}
						>
							You don't pay for unpublished projects.
						</p>
						<p
							style={{
								margin: '0px',
								marginTop: '6px',
								color: 'rgba(0,0,0,0.54)',
								fontSize: '14px',
							}}
						>
							You can publish it again at any time.
						</p>
					</div>
				</div>
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						flexDirection: 'column',
						gap: '10px',
						alignItems: 'center',
					}}
				>
					<p
						style={{
							margin: '0px',
							fontSize: '10px',
							color: 'rgba(0,0,0,0.54)',
							textAlign: 'center',
						}}
					>
						It might take a few seconds.
						<br />
						Please wait.
					</p>
					<Button
						color='error'
						size='medium'
						loading={isUnpublishingProject}
						onClick={unpublishProject}
					>
						Unpublish project
					</Button>
				</div>
			</div>
		</SmallDialog>
	);
};

export default UnpublishProjectConfirmationDialog;
